import { PanelLeft } from 'lucide-react';

import { Button } from '@/shared/components/shadcn/button';

interface CollapsedChatSidebarProps {
  onToggle: () => void;
}

export function CollapsedChatSidebar({ onToggle }: CollapsedChatSidebarProps) {
  return (
    <>
      <div className="h-screen" style={{ width: '48px' }} />
      <div className="bg-muted fixed top-0 right-0 flex h-screen flex-col items-center border-l p-1">
        <Button className="p-3 hover:bg-zinc-200" variant="ghost" size="icon" onClick={onToggle}>
          <PanelLeft className="size-4" />
        </Button>
      </div>
    </>
  );
}
